module.exports = __webpack_public_path__ + "static/media/icon-translation-small.b090859f.svg";